import { CSSObject } from '@chakra-ui/react';

export const SideNavHeading: CSSObject = {
  display: 'none',
};

export const FlexSideLinkWrapper: CSSObject = {
  filter: 'drop-shadow(2px 4px 2px rgba(0, 0, 0, 0.35))',
};
